import { Checkbox } from 'antd'
import PropTypes from 'prop-types'
import { useGetApplications } from 'domains/Application/hooks'
import { useSubfilterActions } from 'hooks'
import { StyledDetails } from '../CustomerFilter.styles'
import { useTranslations } from 'contexts/Translation'
import { Text } from '@qonsoll/react-design'

const ApplicationFilter = ({ filterData, setFilterData }) => {
  // [ADDITIONAL_HOOKS]
  const [applications] = useGetApplications()
  const { t } = useTranslations()

  // [COMPUTED_PROPERTIES]
  const summaryStyles = { marginBottom: '8px' }

  const { onToggleDetails, onChange, checkIsEnabled } = useSubfilterActions({
    filterData,
    setFilterData,
    fieldName: 'applications',
    operand: 'array-contains'
  })

  return (
    <StyledDetails
      open={
        localStorage.getItem(`application-details-visibility`) === 'opened'
      }>
      <summary
        style={summaryStyles}
        onClick={() => onToggleDetails('application')}>
        {t('Application')}
      </summary>
      {applications?.map((application, index) => (
        <div key={`status-${index}`}>
          <Checkbox
            key={`status-${index}`}
            checked={checkIsEnabled(application)}
            onChange={() => onChange(application)}>
            <Text wordBreak="break-all">
              {application?.name || t('Unnamed filter')}
            </Text>
          </Checkbox>
        </div>
      ))}
    </StyledDetails>
  )
}

ApplicationFilter.propTypes = {
  filterData: PropTypes.object,
  setFilterData: PropTypes.func
}

export default ApplicationFilter
